export const Pause = 'Pause';
export const NoPause = 'NoPause';
export const NoPauseWithDeceleration = 'NoPauseWithDeceleration';
export const PauseWithDeceleration = 'PauseWithDeceleration';
export const NoPauseWithStop = 'NoPauseWithStop';
export const HeadPlay = 'HeadPlay';
export const LinearNoPause = 'LinearNoPause';



/** WEBPACK FOOTER **
 ** ./src/constants/BallMovementModes.js
 **/